export default __webpack_public_path__ + "static/media/property_442.624d15b2.png";